import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { useAuth } from '../context/AuthContext';
import './Auth.scss';

const MotDePasseOublie = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    const result = await resetPassword(email);
    
    if (result.success) {
      setMessage(result.message);
      setEmail('');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <PageHeader 
        title="Mot de passe oublié" 
        subtitle="Réinitialisez votre mot de passe"
      />

      <div className="auth-container">
        <div className="auth-split-layout">
          <div className="auth-left-section">
            <div className="auth-content">
              <h2>Récupérez votre compte</h2>
              <p className="intro-text">
                Entrez votre email et nous vous enverrons un lien de réinitialisation.
              </p>
              
              <div className="info-steps">
                <div className="step-item">
                  <div className="step-number">1</div>
                  <div className="step-text">
                    <h4>Entrez votre email</h4>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-number">2</div>
                  <div className="step-text">
                    <h4>Vérifiez votre boîte mail</h4>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-number">3</div>
                  <div className="step-text">
                    <h4>Créez un nouveau mot de passe</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="auth-right-section">
            <div className="auth-card login-card">
            <div className="auth-header compact">
              <h2>Réinitialisation</h2>
            </div>

            {message && (
              <div className="alert alert-success">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                {message}
              </div>
            )}

            {error && (
              <div className="alert alert-error">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="15" y1="9" x2="9" y2="15"/>
                  <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Adresse email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="votre.email@exemple.com"
                  disabled={loading}
                />
              </div>

              <button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
              </button>

              <div className="auth-footer">
                <p>
                  <Link to="/connexion">Retour à la connexion</Link>
                </p>
              </div>
            </form>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default MotDePasseOublie;
